/**
 * ValidationProcurement.jsx — Subtab XV
 */

import React from "react";
import { ConcentricFirewall } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";
import SynthesisBlock from "../SynthesisBlock.jsx";

export default function ValidationProcurement() {
  return (
    <article>
      <SubtabHeading roman="XV">Validation and Procurement</SubtabHeading>
      <ConcentricFirewall />
      <GapBlock>
        Even with a great service, engaging firms need a procurement document
        they can hand to their CFO and CRO. This doesn't currently exist —
        and a service citing IC and defense practices is more credible if it
        has actually been vetted by IC and defense practitioners.
      </GapBlock>
      <SolutionLead>
        A formal advisory structure plus a published procurement specification.
      </SolutionLead>
      <Body>
        <P>
          The advisory board for the service includes, in personal capacity,
          individuals with experience in: SCIF design and operation, data
          diode implementation, classified network architecture (JWICS,
          SIPRNet, or NSAnet operationally), defense industry export control
          compliance, and federal facility clearance administration. Even
          three to five named advisors with credible backgrounds significantly
          elevates the service's authority compared to citing concepts
          academically.
        </P>
        <P>
          For legal credibility, the advisory structure also includes former
          bar ethics committee members, current or former state bar General
          Counsels, and law firm Chief Risk Officers from AmLaw firms. ABA
          Standing Committee on Ethics and Professional Responsibility members
          would be ideal but may have recusal issues if they expect to opine
          on the service formally.
        </P>
        <P>
          For technical credibility, the advisory structure includes current
          or former staff from the major data diode vendors (Owl, Waterfall),
          HSM vendors (Thales, Entrust), and at least one foundation model
          provider's enterprise on-prem team. This is achievable through
          CaseSignalHQ's existing network and through cold outreach with the
          right framing.
        </P>
        <P>
          CoConsoleX is presented at the relevant conferences — Legalweek,
          ILTACON, ABA TECHSHOW for the legal audience; Black Hat, DEF CON
          industrial control systems track, and the SANS ICS conference for
          the technical audience. Conference presentation generates feedback
          and citation pathways.
        </P>
        <P>
          The procurement specification articulates, in language that
          procurement professionals recognize, the technical and operational
          requirements for an air-gapped AI co-counsel engagement: facility
          specifications, certification requirements, personnel clearances,
          insurance minimums, audit rights, SLAs, exit and data return
          provisions, conflict check protocols, and pricing models.
        </P>
        <P>
          Publishing this specification accomplishes two strategic objectives.
          First, it makes adoption easier for engaging firms because the
          procurement legwork is already done. Second, it creates a standard
          against which all market entrants are evaluated — and any vendor
          who can't meet the specification is, by definition, not offering
          the standard.
        </P>
        <P>
          This is exactly how the Cloud Security Alliance's CAIQ became the
          de facto cloud security procurement document, how SOC 2 became the
          SaaS security baseline, and how CMMC is becoming the
          defense-contractor cybersecurity baseline. CaseSignalHQ publishing
          the procurement specification for confidential legal AI puts
          CoConsoleX in the same lineage.
        </P>
      </Body>
      <SynthesisBlock short />
    </article>
  );
}
